/**
 * @module geo/actions/creators
 */
import {INIT_APP} from '../../payload/facade/INIT_APP';
import {GEO_API_PROXY_READY} from '../../payload/proxy/GEO_API_PROXY_READY';
import {TypeKeyActions} from '../types.key.action';
import { actionCreatorsBuilder } from '../helpers/actions.creator.builder';


export const [
  /**
   * return an  action to initialize a application  with custom parameters
   * @since v 2.0.1
   */
  initApplicationCreator,
  /**
   * return an  action to initialize a application  with custom parameters
   * @since v 2.0.1
   */
  initApplicationAsyncCreator,
  /**
   * return an async action to initialize a application  with custom
   * parameters
   * @since v 2.0.1
   * @private
   * @hidden
   */
  initApplicationCreatorP
] = actionCreatorsBuilder<INIT_APP, GEO_API_PROXY_READY, Error>(
  TypeKeyActions.INIT_APP_TYPE
);
